import { __parseDate } from '../../language/translate.js';
import { getAvrgOfNumArray, getYearMonthDayAsString } from './graph-helpers.js';
export function calculate200AVGtoday(items) {
    var dates = items.filter(item => (new Date(item.x)) > new Date(Date.now() - (280 * 24 * 3600 * 1000)))

	var previous_day = (new Date(dates[0].x)).getDate();
	var previous_date = dates[0].x;
	var day_avr = parseFloat(dates[0].y);
	var daily_avrs = [];
	var last_date = dates[dates.length-1].x;

	// calc daily averages:
    // instead of closing prices we take average prices per day (we dont save closing, and crypto has no closng)
    var index = 0;

	dates.forEach((item) => {
		if ((new Date(item.x)).getDate() == previous_day) {
			day_avr+=parseFloat(item.y);
			day_avr = day_avr / 2;
			previous_date = item.x;
			previous_day = (new Date(item.x)).getDate();
		}
		if ((new Date(item.x)).getDate() != previous_day) {
			daily_avrs.push({x: previous_date, y:day_avr});
			day_avr=parseFloat(item.y);
			previous_date = item.x;
			previous_day = (new Date(item.x)).getDate();
            index++;
            if (item.x == last_date) {
                console.log(index)

                daily_avrs.push({x: last_date, y:day_avr});
            }
		}
	});

    return getAvrgOfNumArray(daily_avrs)
}

export function calc_mavr(items, days, group) {
	
	var previous_day = (new Date(items[0].x)).getDate();
	var previous_date = items[0].x;
	var day_avr = parseFloat(items[0].y);
	var daily_avrs = [];
	var last_date = items[items.length-1].x;

	// calc daily averages:
    // instead of closing prices we take average prices per day (we dont save closing, and crypto has no closng)
	items.forEach((item) => {
		if ((new Date(item.x)).getDate() == previous_day) {
			day_avr+=parseFloat(item.y);
			day_avr = day_avr / 2;
			previous_date = item.x;
			previous_day = (new Date(item.x)).getDate();
		}
		if ((new Date(item.x)).getDate() != previous_day) {
			daily_avrs.push({x: previous_date, y:day_avr, group: group});
			day_avr=parseFloat(item.y);
			previous_date = item.x;
			previous_day = (new Date(item.x)).getDate();
            if (item.x == last_date) {
                daily_avrs.push({x: last_date, y:day_avr, group: group});
            }
		}
	});

    // we now have an array with the daily avrgs
    // daily_avrs
    // it has no dates from the same UTC day, only one average price per day

    // now we begin to calc the moving average:
	
	var averages = [];

	// we begin at first data entry (right now -12 months - look at the part where calc_mavr is called!)
	var first_date = daily_avrs[0].x;

	var date_pos = first_date;

	var daily_pos = 0;

    // we fill up -12months until (-12months + "days") to get first moving average value --> we need to look at the first 200 days to find first average in case of 200 EMA
    // so we begin with a SMA for the first price we can calculate --> typically -5years + e.g. 200 days
	
	for (var i=0;i<days;i++) {

		var ymd_avrs = getYearMonthDayAsString(daily_avrs[daily_pos].x);
		var ymd_date = getYearMonthDayAsString(date_pos);
        
        // this (seems ;)) to be a hard exit for some cases where a chart has no values that are -12month old
        if (Date.parse(date_pos) > Date.parse(daily_avrs[0].x) + Date.parse(new Date(280*24*60*60*1000) )) {
            break;
        }
        
		// no date missing
		if (ymd_avrs == ymd_date) {
            averages.push({x: daily_avrs[daily_pos].x, y: daily_avrs[daily_pos].y}); 
			daily_pos++;
			date_pos = new Date(Date.parse(date_pos) + Date.parse(new Date(24*60*60*1000)));
		} 
		// if dates are missing (complex - EZ) interpolate prices
		if (ymd_avrs != ymd_date) {
            try {
                var deltaDays = parseInt((Date.parse(daily_avrs[daily_pos].x)-Date.parse(date_pos))/(24*60*60*1000));
                var deltaPrice = daily_avrs[daily_pos].y - daily_avrs[daily_pos-deltaDays].y;
                var deltaBeginPrice = daily_avrs[daily_pos-deltaDays].y;
                var storeDailyPos = daily_pos;

                for (var di=0;di<deltaDays;di++) {
                    let interpolatedPrice = deltaBeginPrice + ((deltaPrice / (deltaDays+1))*(di+1));
                    averages.push({x: __parseDate(date_pos.toLocaleString("en-US"),"MM-DD-YYYY hh:mm"), y: interpolatedPrice});
                    date_pos = new Date(Date.parse(date_pos) + Date.parse(new Date(24*60*60*1000)));
                }
                daily_pos++;
                averages.push({x: daily_avrs[storeDailyPos].x, y: daily_avrs[storeDailyPos].y}); 
                date_pos = new Date(Date.parse(date_pos) + Date.parse(new Date(24*60*60*1000)));
            } catch (e) {
                daily_pos++;
			    date_pos = new Date(Date.parse(date_pos) + Date.parse(new Date(24*60*60*1000)));
            }
		}
	}

    // we have now a first date with a SMA value
    // now we write the SMA for each leading day into the return_avr
	var return_avr = [];

    do {    

        if (daily_avrs[daily_pos]) {
            var ymd_avrs = getYearMonthDayAsString(daily_avrs[daily_pos].x);
            var ymd_date = getYearMonthDayAsString(date_pos);

            // no date missing
            if (ymd_avrs == ymd_date) {
                averages.shift();
                averages.push({x: (daily_avrs[daily_pos].x), y: daily_avrs[daily_pos].y});
                // every time we shift our e.g. 200 days interest range one day towords "today", we calculate the average on the basis of previous 200 day averages
                var avr_days_y = getAvrgOfNumArray(averages);
                return_avr.push({x: __parseDate(date_pos.toLocaleString("en-US"),"MM-DD-YYYY hh:mm"), y: avr_days_y, group: group});
                daily_pos++;
                date_pos = new Date(Date.parse(date_pos) + Date.parse(new Date(24*60*60*1000)));
       		// if dates are missing (complex - EZ) interpolate prices
            } else {
                try {
                    var deltaDays = parseInt((Date.parse(daily_avrs[daily_pos].x)-Date.parse(date_pos))/(24*60*60*1000));
                    var deltaPrice = daily_avrs[daily_pos].y - daily_avrs[daily_pos-deltaDays].y;
                    var deltaBeginPrice = daily_avrs[daily_pos-deltaDays].y;
                    var storeDailyPos = daily_pos;
                    for (var di=0;di<deltaDays;di++) {
                        let interpolatedPrice = deltaBeginPrice + ((deltaPrice / (deltaDays+1))*(di+1));
                        averages.shift();
                        averages.push({x: __parseDate(date_pos.toLocaleString("en-US"),"MM-DD-YYYY hh:mm"), y: interpolatedPrice});
                        // every time we shift our e.g. 200 days interest range one day towords "today", we calculate the average on the basis of previous 200 day averages
                        var avr_days_y = getAvrgOfNumArray(averages);
                        return_avr.push({x: __parseDate(date_pos.toLocaleString("en-US"),"MM-DD-YYYY hh:mm"), y: avr_days_y, group: group});
                        date_pos = new Date(Date.parse(date_pos) + Date.parse(new Date(24*60*60*1000)));
                    }
                    daily_pos++;
                    averages.shift();
                    averages.push({x: daily_avrs[storeDailyPos].x, y: daily_avrs[storeDailyPos].y}); 
                    date_pos = new Date(Date.parse(date_pos) + Date.parse(new Date(24*60*60*1000)));
                    var avr_days_y = getAvrgOfNumArray(averages);
                    return_avr.push({x: __parseDate(date_pos.toLocaleString("en-US"),"MM-DD-YYYY hh:mm"), y: avr_days_y, group: group});
                } catch (e) {
                    daily_pos++;
                    date_pos = new Date(Date.parse(date_pos) + Date.parse(new Date(24*60*60*1000)));
                }
                
            }
        // not enough dates to calculate
        } else {
            break
        }

	} while (Date.parse(date_pos) < Date.parse(new Date(last_date)))

	return return_avr;
}
